import { Box } from "@material-ui/core"
import { useState,useEffect } from "react";
import { navigate } from '@reach/router'
import AmsTypography from "../../atoms/AmsTypography/AmsTypography";
import "./thankyou.css"
import { Congrats } from "../../assets";
import MessageBlock from "../../molecules/MessageBlock/MessageBlock";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import { useContextSelector } from "@fluentui/react-context-selector";
import { StoreContext } from "../../context";

// import CustomizedRatings from "../../atoms/AmsRating/AmsRating";
const ThankYou = (props:any) => {
   
    const {title,message,messageAlterNate,btnProps} = props?.templateProps;

    const [enableAncilliary,setEnableAncilliary] = useState(true)


    const customerContext: any = useContextSelector(
        StoreContext,
        (store) => store?.appState?.customerJourneyContext
      );

    let junkEnable = customerContext?.customerDetails?.junkEnable
    let storageEnable = customerContext?.customerDetails?.storageEnable

    useEffect(() =>{
        if(junkEnable === 0 && storageEnable ===0){
            setEnableAncilliary(false)
        }
    },[])

      

    const handleSubmit = () => {
        navigate(btnProps?.nextScreen)
    }
    return (
       <Box className="thankyouBlock mainContainer">
            <Box className="title">
                <AmsTypography variant="h1" text={title} />
            </Box>
            <Box className="imgContainer">
                <img src={Congrats} alt="Congrats" />
            </Box>
            <Box className="messageContainer" mb={5}>
                <MessageBlock message={message}/>
            </Box>
            {enableAncilliary && messageAlterNate && <Box className="messageContainer">
                <MessageBlock message={messageAlterNate}/>
            </Box>}
            {/* <Box>
                <CustomizedRatings />
            </Box> */}
            {enableAncilliary && btnProps && <Box className="buttonContainerHome" id="buttonId">
                <AmsButton
                    attributes={btnProps?.attributes}
                    handleClick={handleSubmit}
                />
            </Box>}
       </Box>
        
    )
}

export default ThankYou